import { animated } from 'react-spring'
import { TabColorType } from '.'
import styled from 'styled-components/macro'

export const TabList = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  padding: 0 2rem 0px 1rem;
`

export const Tab = styled.button.attrs({
  role: 'tab',
  type: 'button',
})<{ selected: boolean }>`
  background: none;
  border: none;
  border-bottom: 3px solid var(--border-subtle);
  cursor: pointer;
  flex: 1;
  font-family: inherit;
  font-weight: var(--font-weight-medium);
  font-size: var(--mantine-font-size-sm);
  height: inherit;
  outline: none;
  padding: 1rem 0.5rem;
  text-align: center;
  position: relative;
  user-select: none;
  letter-spacing: var(--letter-spacing-subtle);
  text-transform: uppercase;

  transition: border-color 155ms linear;

  ${({ selected }) =>
    selected &&
    `
    border-color: var(--action-primary);
  `};
`

export const StyledTab = styled(animated.div)<{
  active?: string
}>`
  color: var(--text-heading);
  cursor: ${({ active }) => (active ? 'default' : 'pointer')};
  display: flex;
  font-family: inherit;
  font-weight: var(--font-weight-medium);
  font-size: var(--mantine-font-size-sm);
  letter-spacing: var(--letter-spacing-subtle);
  margin: 0 0.75rem;
  outline: none;
  padding: 1rem 0;
  position: relative;
  text-transform: uppercase;
  user-select: none;
  flex-shrink: 0;

  ${'' /* prevents flash of color on touch devices */};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`

export const IndicatorWrap = styled.div`
  border-radius: var(--mantine-radius-xs);
  height: 4px;
  width: 100%;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  transform: translateY(2.5px);
`

export const Line = styled(animated.div)<{
  focus?: string
  color: TabColorType
}>`
  background-color: ${({ focus, color }) =>
    !!focus
      ? 'var(--pearl-line)'
      : color === 'secondary'
      ? 'var(--action-info)'
      : 'var(--action-primary)'};
  border-radius: inherit;
  position: inherit;
  height: inherit;
  width: inherit;
  transition: background-color 255ms ease-in;
`
